import { api } from '@/lib/api';
import type {
  EmailDomainResponse,
  CreateEmailDomainRequest,
  UpdateEmailDomainRequest,
  EmailDomainDropdownItem,
} from '@troia-v3/types';

/**
 * Servico de API para gerenciamento de dominios de email.
 *
 * Todas as chamadas retornam `response.data.data` conforme envelope do backend.
 */
export const emailDomainsApi = {
  /** Lista todos os dominios de email */
  async getAll(params?: Record<string, unknown>): Promise<EmailDomainResponse[]> {
    const response = await api.get('/email-domains', { params });
    const data = response.data.data;
    return data.items || data;
  },

  /** Busca um dominio por ID */
  async getById(id: string): Promise<EmailDomainResponse> {
    const response = await api.get(`/email-domains/${id}`);
    return response.data.data;
  },

  /** Cria um novo dominio */
  async create(data: CreateEmailDomainRequest): Promise<EmailDomainResponse> {
    const response = await api.post('/email-domains', data);
    return response.data.data;
  },

  /** Atualiza configuracoes de um dominio */
  async update(id: string, data: UpdateEmailDomainRequest): Promise<EmailDomainResponse> {
    const response = await api.put(`/email-domains/${id}`, data);
    return response.data.data;
  },

  /** Remove um dominio */
  async delete(id: string): Promise<void> {
    await api.delete(`/email-domains/${id}`);
  },

  /** Solicita verificacao DNS de um dominio */
  async verify(id: string): Promise<EmailDomainResponse> {
    const response = await api.post(`/email-domains/${id}/verify`);
    return response.data.data;
  },

  /** Checa status de verificacao de um dominio */
  async checkStatus(id: string): Promise<EmailDomainResponse> {
    const response = await api.get(`/email-domains/${id}/check-status`);
    return response.data.data;
  },

  /** Lista dominios para dropdown (formato simplificado) */
  async getForDropdown(): Promise<EmailDomainDropdownItem[]> {
    const response = await api.get('/email-domains/dropdown');
    return response.data.data;
  },
};
